import { watch, type ComputedRef, type Ref } from 'vue'
import { useSourceToast } from '~/composables/ui/useSourceToast'
import type { EditScopeNotice } from '~~/utils/auth/orgEditScopeNotice'

const LIMITED_EDIT_TOAST_MS = 12_000

/**
 * Annonce une fois par activation du mode édition, dès que le périmètre est connu.
 * Le toast disparaît ; le contour n’est dessiné par les pages que si une partie de l’écran
 * reste hors périmètre. Si toute la page est modifiable, aucun contour n’est ajouté.
 */
export function useEditScopeToast(
  isEditing: Ref<boolean>,
  notice: ComputedRef<EditScopeNotice | null>,
): void {
  const toast = useSourceToast()
  let announced = false

  watch(isEditing, (editing) => {
    if (!editing) {
      announced = false
    }
  })

  watch(
    [isEditing, notice],
    ([editing, next]) => {
      if (!editing || next === null || announced) {
        return
      }
      announced = true
      toast.info(next.title, next.description, LIMITED_EDIT_TOAST_MS)
    },
    { immediate: true },
  )
}
